import type { IconProps } from "./icon-types";

/**
 * 그리드(카드) 보기. 데이터 컬렉션을 카드 그리드로 표시하는 뷰 전환에서 사용
 * (DataGridView ↔ DataTable 토글 등). 2×2 라운드 사각형 스트로크.
 */
export const GridViewIcon = (props: IconProps) => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" aria-hidden="true" {...props}>
    <path
      d="M3 3h3.5v3.5H3V3Zm6.5 0H13v3.5H9.5V3ZM3 9.5h3.5V13H3V9.5Zm6.5 0H13V13H9.5V9.5Z"
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);
